
import { defineComponent, ref, reactive, toRefs, onMounted, computed, nextTick, watch } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import { init, ECharts, EChartsOption } from 'echarts'
import Charts from '@/components/page/charts.vue'
import globalsets from '@/utils/globalsets'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { Table, Charts, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      columns: [],
      data: [],
      spinning: true
    })
    const color = globalsets.getColor()
    pageData.columns = [
      {
        title: '年份',
        dataIndex: 'Year',
        key: 'Year'
        // width: "100px"
      },
      {
        title: '分红总额(元)',
        dataIndex: 'TotalDividend',
        key: 'TotalDividend',
        width: '130px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '增发(股)',
        dataIndex: 'AdditionalIssuance',
        key: 'AdditionalIssuance',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '配股(股)',
        dataIndex: 'Allotment',
        key: 'Allotment',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '新股发行(股)',
        dataIndex: 'NewSharesIssuance',
        key: 'NewSharesIssuance',
        slots: { customRender: 'peopleCount' }
        // width: "100px"
      }
    ]
    // pageData.data = computed(()=>{
    //   nextTick(()=>{
    //     pageData.spinning = false
    //   })
    //   return myData
    // })
    watch(
      () => (props.pageSourceData || {}).DividendFinanceHistoryData,
      () => {
        const data = (props.pageSourceData || {}).DividendFinanceHistoryData
        pageData.data = handlerData(data)
      },
      { deep: true }
    )
    function handlerData(arr: any) {
      nextTick(() => {
        pageData.spinning = false
      })
      if ((arr || []).length < 1) return []
      arr.forEach((item: any, i: number) => {
        item.index = 'Lnfhrz' + i
      })
      return arr
    }
    return {
      ...toRefs(pageData)
    }
  }
})
